import { Link } from "react-router-dom";
import moment from "moment-timezone";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { CardSolidGame } from "./CardSolidGame";
import FudopiaHero from "../assets/Fudopia hero.webp";
import WhyFudopia from "../Components/WhyFudopia";
import HowItWorks from "../Components/HowItWorks";

import usePageTitle from "../hooks/usePageTitle";
import useHomePage from "../hooks/useHomePage";
import { useAuth } from "../hooks/useAuth";

function HomePage() {
  const { dishes, events, error } = useHomePage();
  const { authed } = useAuth();

  usePageTitle(`Fudopia | Meet. Eat. Repeat.`);

  const futureEvents = events.filter((event) => {
    return moment(event.date).isAfter(moment().tz(event.timezone));
  });

  return (
    <div className="home">
      {error && <p className="error-message">Something went wrong...</p>}

      <div className="section hero">
        <h1>Meet new people through food</h1>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            marginTop: 2,
          }}
        >
          <p className="bigger">
            Join small foodie meetups. <br />
            Discover local dishes. <br />
            Connect over good vibes and even better bites.
          </p>
        </Box>
        <Box sx={{ mt: 2, marginBottom: "38px" }}>
          {!authed && (
            <Link to="/register">
              <Button color="primary" variant="contained">
                Join Fudopia
              </Button>
              <p
                className="remark centered"
                style={{ textAlign: "center", marginTop: "20px" }}
              >
                🔓 Free for the first 200 users with full access for a whole
                year!
              </p>
            </Link>
          )}
          {authed && (
            <p
              className="remark centered"
              style={{ textAlign: "center", marginTop: "20px" }}
            >
              🔓 Free for the first 200 users with full access for a whole year!
            </p>
          )}
        </Box>
        <Box>
          <img
            className="hero-img"
            src={FudopiaHero}
            alt="Friends enjoying food and drinks together at cozy cafes and restaurants, laughing and sharing meals."
          />
        </Box>
      </div>
      <div className="section">
        <div
          style={{
            marginTop: "27px",
            background: "#fff",
            padding: "13px 40px 40px 40px",
            borderRadius: "16px",
          }}
        >
          <HowItWorks />
        </div>
      </div>
      {dishes ? (
        <>
          <div className="section">
            <h2>Trending Dishes & Drinks in Bangkok</h2>
            <p className="max-w-500">
              With so much good food and drink in Bangkok, it’s hard to choose.{" "}
              <br />
              But these picks are a delicious place to start.
            </p>
          </div>
          <div className="block-wrapper dishes grid">
            <CardSolidGame dishes={dishes} />
          </div>
          <div className="btn-wrapper">
            <Link to="/dishes">
              <Button color="primary" variant="contained">
                Browse All Dishes & Drinks
              </Button>
            </Link>
          </div>
        </>
      ) : (
        <div className="section">
          <h2 className="centered">
            There are no dishes at the moment. <br />
            Come back later!
          </h2>
        </div>
      )}
      {futureEvents.length > 0 ? (
        <div className="section">
          <h2>Upcoming Events in Bangkok</h2>
          <p className="max-w-500">
            Want to share a meal with others? <br />
            These events are happening soon around Bangkok.
          </p>
          <div className="block-wrapper events">
            {futureEvents.map((event, key) => (
              <div key={key} className="block">
                <Link to={`/events/${event.id}`}>
                  <h2>{event.title}</h2>
                </Link>
                <h3 className="subheader">Date & Time</h3>
                <span>
                  {moment(event.date)
                    .tz(event.timezone)
                    .format(
                      authed ? "dddd, MMMM Do · h:mm a" : "dddd, MMMM Do"
                    )}
                </span>
                {event.tags.length > 0 && (
                  <>
                    <h3 className="subheader">Meetup Mood</h3>
                    <ul className="tags-list">
                      {event.tags.map((tag) => (
                        <li key={tag.id}>{tag.title}</li>
                      ))}
                    </ul>
                  </>
                )}
                <h3 className="subheader">What are we trying?</h3>
                <img
                  src={event.dish.image_url}
                  alt={event.dish.title}
                  className="event-dish"
                />
              </div>
            ))}
          </div>
          <div className="btn-wrapper">
            <Link to="/events">
              <Button color="primary" variant="contained">
                See All Events
              </Button>
            </Link>
          </div>
        </div>
      ) : (
        <div className="section">
          <h2 className="centered">
            There are no events at the moment. <br />
            But you can create one!
          </h2>
          <p>Choose a dish to try at your next event</p>
          <Link to="/dishes">
            <Button color="primary" variant="contained" size="small">
              See All Dishes & Drinks
            </Button>
          </Link>
        </div>
      )}
      <WhyFudopia />
    </div>
  );
}

export default HomePage;
